module.exports = __webpack_public_path__ + "img/Niedersachsische.d0c9db5b.png";